var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{ref:"mouse",staticClass:"mouse",style:(("transition: transform " + (_vm.transitionTimeMs / 1000) + "s;")),attrs:{"viewBox":"11.8 9 16 22","id":"mouse"}},[_c('path',{attrs:{"d":"M20,21l4.5,8l-3.4,2l-4.6-8.1L12,29V9l16,12H20z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }